/*
  Kiomia · il nome e i numeri del Quiz dell'acqua, riusati nelle altre pagine.

  Il quiz salva in sessionStorage il nome di chi lo ha fatto, il suo comune, la
  classe dell'acqua e quanti mesi le dura il filtro della confezione. Questo
  file prende quei valori e li infila dentro qualunque elemento marcato
  data-km-tu, sostituendo i segnaposto fra graffe:

      {nome}    Giulia
      {luogo}   Pistoia
      {acqua}   dura           (senza la parola "acqua" davanti, minuscolo)
      {classe}  Acqua dura     (come la chiama il quiz)
      {filtri}  3              (quanto dura il filtro con quell'acqua)
      {mesi}    3              (fra quanto si sente il velo, se oggi non si sente)
      {cap}     51100

  Il testo originale viene messo da parte in data-km-tu-src la prima volta, cosi'
  la sostituzione si puo' rifare piu' volte senza mangiarsi il testo.

  Un elemento con data-km-tu-nome resta nascosto finche' non c'e' un nome: serve
  per le righe che senza nome non avrebbero senso. Si nasconde con lo style, non
  con [hidden], perche' [hidden] lo perde qualunque regola che imposti display.

  Non salva niente e non manda niente da nessuna parte: legge solo quello che il
  quiz ha gia' messo nella sessione di quel browser.
*/
(function(){
  function leggi(){
    var d = { nome:'', luogo:'', acqua:'', classe:'', filtri:'', mesi:'', cap:'' };
    try{
      d.nome   = sessionStorage.getItem('kmNome') || '';
      d.luogo  = sessionStorage.getItem('kmLuogo') || '';
      d.classe = sessionStorage.getItem('kmAcquaNome') || '';
      d.acqua  = d.classe.replace(/^acqua\s+/i,'').toLowerCase();
      d.filtri = sessionStorage.getItem('kmMesiFiltri') || '';
      d.mesi   = sessionStorage.getItem('kmMesi') || '';
      d.cap    = sessionStorage.getItem('kmCap') || '';
    }catch(e){}
    return d;
  }

  function riempi(t, d){
    return String(t==null?'':t).replace(/\{(\w+)\}/g, function(m,k){
      return (d[k] === undefined || d[k] === null) ? '' : d[k];
    });
  }

  function applica(root){
    var d = leggi();
    window.KM_TU = d;
    try{
      if (d.nome) document.documentElement.classList.add('km-ha-nome');
      else document.documentElement.classList.remove('km-ha-nome');
    }catch(e){}

    var n = (root || document).querySelectorAll('[data-km-tu]');
    for (var i = 0; i < n.length; i++){
      var el = n[i];
      var src = el.getAttribute('data-km-tu-src');
      if (src === null){ src = el.textContent || ''; el.setAttribute('data-km-tu-src', src); }
      if (el.hasAttribute('data-km-tu-nome') && !d.nome){ el.style.display = 'none'; continue; }
      var t = riempi(src, d).replace(/\s{2,}/g, ' ').trim();
      if (!t){ el.style.display = 'none'; continue; }
      el.style.display = '';
      el.textContent = t;
    }
  }

  window.KM_TU_APPLICA = applica;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ applica(document); });
  else applica(document);
  document.addEventListener('shopify:section:load', function(e){ applica(e.target); });
  document.addEventListener('km:quiz', function(){ applica(document); });
})();
